import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Meetings from "../Meetings";
import CrmCaseLogs from "../Crm/CrmCaseLogs";
import Person from '../Person';

export default class PersonCard extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.PersonId,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            caller: props.Caller,
            data: null,
            loading: true,
            showMeetingsHistory: this.isNull(props.ShowMeetingsHistory) ? true : props.ShowMeetingsHistory,
            showCrmLogHistory: this.isNull(props.ShowCrmLogHistory) ? true : props.ShowCrmLogHistory,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/person/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getGroupChecked(groupId) {
        var t = false;
        this.state.data.categories.forEach(f => {
            if (f === groupId) t = true;
        });
        return t;
    }
    fieldInCategory(field) {
        var find = false;
        this.state.data.categories.forEach(f => {
            if (field.crmCaseCategoriesId.includes(f)) find = true;
        });
        return find;
    }
    onEditPerson(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} Id={id} RefreshAfterSave={false} /> });
    }
    renderView() {
        return <div className="container-fluid">
            <ul className="nav nav-tabs mt-n3">
                <li className="nav-item">
                    <a className="nav-link active" data-bs-toggle="tab" href="#info"><em className="icon ni ni-info"></em><span>اطلاعات شخص</span></a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#contact"><em className="icon ni ni-info"></em><span>اطلاعات تماس</span></a>
                </li>
                {this.state.data.record.type == 1 && <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#personal"><em className="icon ni ni-info"></em><span>اطلاعات پرسنلی</span></a>
                </li>}
                <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#fields"><em className="icon ni ni-info"></em><span>اطلاعات سفارشی</span></a>
                </li>
                {this.state.showMeetingsHistory && <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#meetings"><em className="icon ni ni-info"></em><span>سوابق جلسات</span></a>
                </li>}
                {this.state.showCrmLogHistory && <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#crmlogs"><em className="icon ni ni-info"></em><span>سوابق کلیه پیگیری ها</span></a>
                </li>}
            </ul>

            <div className="tab-content">
                <div className="tab-pane active" id="info">
                    <div className="row">
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="title1">{this.state.data.record.type === 1 ? "نام و نام خانوادگی" : "عنوان"}: {this.state.data.record.name}
                                    <a className="hand" onClick={e => this.onEditPerson(this.state.data.record.id)} title="ویرایش اطلاعات">
                                        <em className="icon ni ni-pen"></em>
                                    </a>
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="form-group">
                                <label className="title1">کد: {this.state.data.record.code}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">نوع شخص: {this.state.data.record.typeString}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">{this.state.data.record.type === 1 ? "کدملی" : "شناسه ملی"}: {this.state.data.record.nationalId}</label>
                            </div>
                        </div>
                        {this.state.data.record.type !== 2 && <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">کداقتصادی: {this.state.data.record.economicCode}</label>
                            </div>
                        </div>}
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">کد شعبه: {this.state.data.record.branchCode}</label>
                            </div>
                        </div>
                        {this.state.data.record.type !== 2 && <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شماره گذرنامه: {this.state.data.record.pasportNo}</label>
                            </div>
                        </div>}
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شماره شناسنامه: {this.state.data.record.shenasname}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">نام پدر: {this.state.data.record.fatherName}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">وضعیت تاهل: {this.state.data.record.marriageString}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">تاریخ تولد: {this.state.data.record.birthDate}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">جنسیت: {this.state.data.record.genderString}</label>
                            </div>
                        </div>
                        {this.state.data.record.type == 1 &&
                            <div className="col-lg-2">
                                <div className="form-group">
                                    <label className="form-label">میزان تحصیلات: {this.state.data.record.educationGradeString}</label>
                                </div>
                            </div>
                        }
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">مقطع: {this.state.data.record.magta}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">رشته: {this.state.data.record.field}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شغل: {this.state.data.record.job}</label>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-label">سابقه: {this.state.data.record.sabege}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-label">گروه ها</label>
                                <div className="form-control-wrap">
                                    {this.state.data.groups.map(group => this.getGroupChecked(group.id) && <span className="me-4" style={{ "display": "inline-block" }}>{group.name}</span>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane" id="contact">
                    <div className="row">
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شماره موبایل: {this.state.data.record.mobile}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شماره تلفن: {this.state.data.record.phone}</label>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label className="form-label">آدرس ایمیل: {this.state.data.record.email}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">کدپستی: {this.state.data.record.zipCode}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">کشور: {this.state.data.record.country}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">استان/ایالت: {this.state.data.record.province}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شهر: {this.state.data.record.city}</label>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-label">آدرس: {this.state.data.record.address}</label>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.data.record.type == 1 && <div className="tab-pane" id="personal">
                    <div className="row">
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">کدپرسنلی: {this.state.data.record.code}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">محل تولد: {this.state.data.record.birthLocation}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">محل صدور: {this.state.data.record.sodor}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">تاریخ استخدام: {this.state.data.record.registerDate}</label>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">تعداد فرزند: {this.state.data.record.childrenCount}</label>
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="tab-pane" id="fields">
                    <div className="row">
                        {this.state.data.baseFieldValues.map(field => this.fieldInCategory(field) && [
                            field.dataType === 1 && <div className="col-sm-12">
                                <div className="form-group">
                                    <label for="name" className="title1">{field.label}: {field.value}</label>
                                </div>
                            </div>
                            ,
                            field.dataType === 2 && <div className="col-sm-3">
                                <div className="form-group">
                                    <label for="name" className="title1">{field.label}: {field.value}</label>
                                </div>
                            </div>
                            ,
                            field.dataType === 3 && <div className="col-sm-3">
                                <div className="form-group">
                                    <label for="name" className="title1">{field.label}: {this.getFormatedDateForDatePicker(field.value)}</label>
                                </div>
                            </div>
                        ])}
                    </div>
                </div>                
                {this.state.showMeetingsHistory && <div className="tab-pane" id="meetings">
                    <Meetings ForMe={false} PersonId={this.state.data.record.id} Inline={true} />
                </div>}
                {this.state.showCrmLogHistory && <div className="tab-pane" id="crmlogs">
                    <CrmCaseLogs PersonId={this.state.data.record.id} />
                </div>}                
            </div>
        </div>
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{"width":"96%"} }>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                کارت اطلاعات شخص
                            </h4>
                        </div>
                        <div className="modal-body">
                            {this.renderView()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderView() : this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}